import React from "react"
import CircularProgress from '@mui/material/CircularProgress';
const Loading = (props) => {
    const { title } = props
    return (
        <div style={{ width: '100%', display: 'flex', height: 50, alignItems: 'center', justifyContent: 'center' }}>
            <CircularProgress
                className="troubleshoot-device-loading"
                size={30}
            />
            <span style={{ marginLeft: 5 }}>{title}</span>
        </div>
    )
}

export default Loading